import { Injectable } from '@angular/core';

import { Script } from '../../models/entity/script.interface';

@Injectable({
  providedIn: 'root',
})
export class ScriptService {
  private scripts: Map<string, any> = new Map<string, any>();
  constructor() { }

  loadScript(script: Script): Promise<any> {
    if (!this.scripts.has(script.name)) {
      this.scripts.set(script.name, {
        loaded: false,
        src: script.src,
      });
    }
    return new Promise((resolve) => {
      // resolve if already loaded
      if (this.scripts.get(script.name).loaded) {
        resolve({ script: script.name, loaded: true, status: 'Already Loaded' });
      } else {
        // load script
        const scriptElement = document.createElement('script');
        scriptElement.type = 'text/javascript';
        scriptElement.src = this.scripts.get(script.name).src;
        scriptElement.onload = (): void => {
          this.scripts.get(script.name).loaded = true;
          resolve({ script: script.name, loaded: true, status: 'Loaded' });
        };
        scriptElement.onerror = (): void =>
          resolve({ script: script.name, loaded: false, status: 'Loaded' });
        document.getElementsByTagName('head')[0].appendChild(scriptElement);
      }
    });
  }
}
